import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/organizations/update';
import { operation as loadDetail } from './detail';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

function* operation(action) {
  const { orgId, body, includeSso } = action.payload;
  try {
    yield call(
      axios.put,
      `${config.API_URL}/organization/${orgId}`,
      body,
      { headers: getLocalUser() },
    );
    yield put({ type: 'SHOW_SUCCESS_SNACKBAR', message: 'Organization settings saved' });
    // Refresh the detail slice before releasing the saving flag (mirrors
    // the old "await loadOrg(orgId)" after saving).
    yield call(loadDetail, { payload: { orgId, includeSso } });
    yield put(fetchSuccess({ orgId }));
  } catch (err) {
    yield put(ErrorAction(err));
    const message = err?.response?.data?.message || 'Could not save settings';
    yield put({ type: 'SHOW_ERROR_SNACKBAR', message });
    yield put(fetchFailure(message));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
